import { PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthStateService } from '../services/auth-state.service';

export const authGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  // localStorage is unavailable on the server — defer auth to the client
  if (!isPlatformBrowser(inject(PLATFORM_ID))) return true;

  const auth = inject(AuthStateService);
  const router = inject(Router);

  if (auth.isLoggedIn()) return true;

  // Pass attempted URL so login can redirect back after success
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url }
  });
};

export const guestGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
) => {
  // localStorage is unavailable on the server — defer auth to the client
  if (!isPlatformBrowser(inject(PLATFORM_ID))) return true;

  const auth = inject(AuthStateService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) return true;

  const returnUrl = route.queryParamMap.get('returnUrl');
  const target =
    returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')
      ? returnUrl
      : '/portal/overview';
  return router.parseUrl(target);
};
